import {
  NotificationCategory,
  NotificationSourceType,
} from "../types/notification.types";

export const NOTIFICATION_SOURCE_ROUTES: Partial<Record<
  NotificationSourceType,
  string
>> = {
  [NotificationSourceType.WORK_ORDER]: "/work-orders",
  [NotificationSourceType.AMC]: "/amc-management",
  [NotificationSourceType.AMC_VISIT]: "/amc-visits",
  [NotificationSourceType.PETTY_WORK]: "/petty-works",
  [NotificationSourceType.SITE_VISIT]: "/enquiry-management/site-visits",
  [NotificationSourceType.ENQUIRY]: "/enquiry-management/enquiries",
  [NotificationSourceType.LEAVE_APPLICATION]:
    "/hr-management/leave-applications",
  [NotificationSourceType.PAYMENT_EXPECTATION]: "/finance/payment-expectations",
  [NotificationSourceType.PAYROLL_RUN]: "/finance/payroll",
};

export const NOTIFICATION_CATEGORY_ICON: Record<
  NotificationCategory,
  { icon: string; cls: string }
> = {
  [NotificationCategory.WORK_ASSIGNMENT]: {
    icon: "ri-briefcase-2-line",
    cls: "bg-primary-subtle text-primary",
  },
  [NotificationCategory.LEAVE_APPLICATION]: {
    icon: "ri-rest-time-line",
    cls: "bg-info-subtle text-info",
  },
  [NotificationCategory.WORK_ORDER_BILLING]: {
    icon: "ri-bill-line",
    cls: "bg-warning-subtle text-warning",
  },
  [NotificationCategory.PAYMENT_EXPECTATION_FOLLOW_UP]: {
    icon: "ri-alarm-warning-line",
    cls: "bg-danger-subtle text-danger",
  },
  [NotificationCategory.PAYROLL]: {
    icon: "ri-money-dollar-circle-line",
    cls: "bg-success-subtle text-success",
  },
  [NotificationCategory.SECURITY]: {
    icon: "ri-shield-keyhole-line",
    cls: "bg-danger-subtle text-danger",
  },
  [NotificationCategory.WORK_ASSIGNMENT_REMOVAL]: {
    icon: "ri-user-unfollow-line",
    cls: "bg-warning-subtle text-warning",
  },
  [NotificationCategory.AMC_READY_FOR_ACTIVATION]: {
    icon: "ri-check-double-line",
    cls: "bg-success-subtle text-success",
  },
  [NotificationCategory.AMC_ACTIVATION]: {
    icon: "ri-play-circle-line",
    cls: "bg-warning-subtle text-warning",
  },
  [NotificationCategory.AMC_COMPLETION]: {
    icon: "ri-checkbox-circle-line",
    cls: "bg-primary-subtle text-primary",
  },
  [NotificationCategory.AMC_CANCELLATION]: {
    icon: "ri-close-circle-line",
    cls: "bg-danger-subtle text-danger",
  },
};

export const NOTIFICATION_DEFAULT_ICON = {
  icon: "ri-notification-3-line",
  cls: "bg-primary-subtle text-primary",
};

export const NOTIFICATION_PAGE_SIZE = 15;

export const NOTIFICATION_BADGE_CAP = 99;
